<div class="simple-banner-container" [ngClass]="bannerTypeClass">
  <mat-icon class="simple-banner-icon">{{ icon }}</mat-icon>

  <div class="simple-banner-content">
    <div class="simple-banner-title">
      <ng-content select="[title]"></ng-content>
    </div>

    <div class="simple-banner-text">
      <ng-content select="[text]"></ng-content>
    </div>
  </div>
</div>
